module.exports = __webpack_public_path__ + "static/media/Publication-stats.d4265c33.png";